import { render, staticRenderFns } from "./No02.vue?vue&type=template&id=2d6748ea&scoped=true"
import script from "./No02.vue?vue&type=script&lang=js"
export * from "./No02.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6748ea",
  null
  
)

export default component.exports